import React from 'react'
import { useStyles } from '../style'
import { CheckCircle } from '@mui/icons-material'
import { Box, Typography } from '@mui/material'
import { SignInForm } from '@emerald-works-nova/auth'
import { routes } from '../../../routes'

const Verified = () => {
  const classes = useStyles()

  return (
    <>
      <Typography className={classes.heading}>
        <CheckCircle /> Your email address has been verified
      </Typography>
      <Box className={classes.containerContent}>
        <>
          <Typography className={classes.subtitle}>
            Enter your email address below and we’ll get you back on track.
          </Typography>
          <SignInForm redirectRoute={routes.home.path} />
        </>
      </Box>
    </>
  )
}

export default Verified
